import React from 'react';
function Layout(props) {
  return (
    <React.Fragment>
      <main>
        {props.children}
      </main>
    </React.Fragment>
  );
}
export default Layout;